import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';
import { ADMIN_AI_API_URL } from './constants';

/**
 * PUT /chatbot-analytics/cancel-licence — marks the business's AI assistant
 * licence row cancelled; system admin only. Built by hand because the signed
 * request helpers have no PUT variant.
 */
export const cancelAiLicence = async (businessId) => {
  const apiPath = 'chatbot-analytics/cancel-licence';
  const body = { businessId };
  const signedRequest = await createSignedRequest({
    url: `${ADMIN_AI_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'PUT',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body), // aws4 signs body; axios sends data
    data: body,
  });
  const response = await axios(signedRequest);
  return response.data;
};
